export const cartKeys = {
    all: ['cart'] as const,
    view: () => [...cartKeys.all, 'view'] as const
} as const;

// Caching: useCart() sets staleTime 30s / gcTime 5min (see use-cart.ts) to absorb the burst of
// independent useCart() mounts across mini-cart/cart page/cart-header-desktop/payment page —
// not staleness tolerance. All mutations below patch the cache synchronously via setQueryData,
// so freshness after an in-app action never depends on staleTime.

// Invalidations:
// useAddToCart                → cartKeys.view() (setQueryData via syncCartCache, response carries the cart;
//                               skipped with shouldSyncCartOnSuccess: false — bundle card, remove-duplicated syncs instead)
// useRemoveFromCart           → cartKeys.view() (setQueryData via syncCartCache)
// useRemoveDuplicatedFromCart → cartKeys.view() (setQueryData via syncCartCache)
// useApplyVoucher             → cartKeys.view() (setQueryData via syncCartCache)
// useRemoveVoucher            → cartKeys.view() (setQueryData via syncCartCache)
// useAttachCredits/useDetachCredits → cartKeys.view() (refetchCart — response not parsed, see services/credits/*)
//
// useCart() / useCartCount() share this key via cartViewQueryOptions — one cache entry, no bridge to Redux
// (removed FE-249 stage 3; state.main.cart no longer exists, consume useCart()/useCartCount() directly).

// Shared fetchers already migrated:
// cart-service.ts add/remove/removeDuplicated → src/api/cart/{add-to-cart,remove-from-cart,remove-duplicated-from-cart}.ts
// voucher.ts save/remove → src/api/cart/{apply-voucher,remove-voucher}.ts
// (voucher.ts's `generate` export stays at src/api/vouchers/generate-voucher.ts — unrelated promo-code flow, not migrated)
